<template>
    <div class="row align-items-start">
        <div class="col-lg-4 mb-25" v-if="show_centers">
            <div class="card h-100 border-0 rounded-0 bg-white letter-spacing lead-info-box rounded-0">
                <div class="card-body p-15 p-sm-20 p-md-25 stats-box">
                    <!-- <div class="d-flex flex-column gap-3"> -->
                    <div class="stats-grid">
                        <div class="title">
                            <span class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis">{{
                                $t('feature.home.$stats.centers_count') }}</span>
                            <h4 class="fw-black mb-8 lh-1">{{ stats?.centers_count ?? '-' }}</h4>
                        </div>
                        <div class="title">
                            <span class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis">{{
                                $t('feature.home.$stats.countries_count') }}</span>
                            <h4 class="fw-black mb-8 lh-1">{{ stats?.countries_count ?? '-' }}</h4>
                        </div>
                    </div>
                    <div class="mt-3 d-flex flex-column align-items-start justify-content-end mt-auto gap-2">
                        <router-link :to="{ path: `/system-centers` }">
                            <button type="button"
                                class="card-link-btn border-0 bg-transparent p-0 text-decoration-none text-primary fw-medium position-relative d-inline-block">
                                {{ $t("page.centers") }}
                            </button>
                        </router-link>
                        <router-link :to="{ path: `/create-center` }">
                            <button type="button"
                                class="card-link-btn border-0 bg-transparent p-0 text-decoration-none text-primary fw-medium position-relative d-inline-block">
                                {{ $t("cta.create_center") }}
                            </button>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-4 mb-25" v-if="show_users">
            <div class="card h-100 border-0 rounded-0 bg-white letter-spacing lead-info-box rounded-0">
                <div class="card-body p-15 p-sm-20 p-md-25 stats-box">
                    <div class="title mb-3">
                        <span class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis">{{
                            $t('feature.home.$stats.total_hcps') }}</span>
                        <h4 class="fw-black mb-8 lh-1">{{ total_hcps ?? '-' }}</h4>
                    </div>
                    <div class="stats-grid">
                        <div class="title" v-for="user in stats?.users_count" :key="user.role_id"><span
                                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis">{{
                                    user.role_name }}</span>
                            <h4 class="fw-black mb-8 lh-1">{{ user.count ?? '-' }}</h4>
                        </div>
                    </div>
                    <!-- <div class="mt-3 d-flex flex-column align-items-start justify-content-end mt-auto gap-2">
                        <router-link :to="{ path: `/create-user` }">
                            <button type="button"
                                class="card-link-btn border-0 bg-transparent p-0 text-decoration-none text-primary fw-medium position-relative d-inline-block">
                                {{ $t("cta.create_user") }}
                            </button>
                        </router-link>
                    </div> -->
                </div>
            </div>
        </div>
        <div class="col-lg-4 mb-25" v-if="show_patients">
            <div class="card h-100 border-0 rounded-0 bg-white letter-spacing lead-info-box rounded-0">
                <div class="card-body p-15 p-sm-20 p-md-25 stats-box">
                    <div class="stats-grid">
                        <div class="title">
                            <span class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis">{{
                                $t('feature.home.$stats.patients_invited_count') }}</span>
                            <h4 class="fw-black mb-8 lh-1">{{ stats?.patients_invited_count ?? '-' }}</h4>
                        </div>
                        <div class="title">
                            <span class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis">{{
                                $t('feature.home.$stats.cargivers_count') }}</span>
                            <h4 class="fw-black mb-8 lh-1">{{ stats?.cargivers_count ?? '-' }}</h4>
                        </div>
                        <div class="title">
                            <span class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis">{{
                                $t('feature.home.$stats.patients_activated_count') }}</span>
                            <h4 class="fw-black mb-8 lh-1">{{ stats?.patients_activated_count ?? '-' }}</h4>
                        </div>
                        <div class="title">
                            <span class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis">{{
                                $t('feature.home.$stats.therapies_started_count') }}</span>
                            <h4 class="fw-black mb-8 lh-1">{{ therapies_started_count ?? '-' }}</h4>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="col-sm-6 col-md-6 col-lg-4 mb-25" v-if="centers">
            <div class="card h-100 border-0 rounded-0 bg-white letter-spacing lead-info-box rounded-0">
                <div class="card-body p-15 p-sm-20 p-md-25 stats-box">
                    <div class="d-flex flex-column gap-3">
                        <div class="title" v-for="(value, key) in centers" :key="key">
                            <span class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis">{{
                                $t(`feature.home.$stats.${key}`) }}</span>
                            <h4 class="fw-black mb-8 lh-1">{{ value ?? '-' }}</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-4 mb-25" v-if="users">
            <div class="card h-100 border-0 rounded-0 bg-white letter-spacing lead-info-box rounded-0">
                <div class="card-body p-15 p-sm-20 p-md-25 stats-box">
                    <div class="d-flex flex-column gap-3">
                        <div class="title" v-for="user in users.users_count" :key="user.role_id"><span
                                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis">{{
                                    user.role_name }}</span>
                            <h4 class="fw-black mb-8 lh-1">{{ user.count ?? '-' }}</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</template>


<style lang="scss">
.stats-grid {
    display: grid;
    gap: 1rem;
    grid-template-columns: 1fr;

    @media screen and (min-width: 576px) {
        grid-template-columns: 1fr 1fr;
    }

    @media screen and (min-width: 768px) {
        grid-template-columns: 1fr 1fr 1fr 1fr;
    }

    @media screen and (min-width: 992px) {
        grid-template-columns: 1fr 1fr;
    }
}
</style>

<script lang="ts">
import { defineComponent } from 'vue';
import API from '@/services/api/api.service';
import { StatisticsCenters, StatisticsPatients, StatisticsUsers } from '@/utils/models/statistic.model';

interface Statistics extends StatisticsCenters, StatisticsUsers, StatisticsPatients { };

export default defineComponent({
    name: "QuickLook",
    mounted() {
        this.loadStats();
    },
    data: function () {
        return {
            centers: undefined as StatisticsCenters | undefined,
            patients: undefined as StatisticsPatients | undefined,
            users: undefined as StatisticsUsers | undefined,
            stats: undefined as Statistics | undefined,
        }
    },
    methods: {
        loadStats() {
            /* this.loadCenterStats();
            this.loadPatientsStats();
            this.loadUsersStats(); */
            Promise.allSettled([API.getStatsCenters(), API.getStatsPatients(), API.getStatsUsers()]).then((responses) => {
                let success = responses.filter((response) => response.status === 'fulfilled' && response.value.data.success === true);
                this.stats = (success.map((res) => (res as PromiseFulfilledResult<any>).value.data.data)).flat().reduce((a, b) => { return { ...a, ...b } });
                console.debug('STATISTICS', this.stats)
            });
        },
        loadCenterStats() {
            API.getStatsCenters().then((response) => {
                if (response.data.success === true) {
                    this.centers = response.data.data.shift();
                }
            });
        },
        loadPatientsStats() {
            API.getStatsPatients().then((response) => {
                if (response.data.success === true) {
                    this.patients = response.data.data.shift();
                }
            });
        },
        loadUsersStats() {
            API.getStatsUsers().then((response) => {
                if (response.data.success === true) {
                    this.users = response.data.data.shift();
                }
            });
        },
    },
    computed: {
        show_centers(): boolean {
            return this.stats != undefined && (('centers_count' in this.stats) || ('countries_count' in this.stats));
        },
        show_users(): boolean {
            return this.stats != undefined && ('users_count' in this.stats);
        },
        show_patients(): boolean {
            return this.stats != undefined && (('patients_invited_count' in this.stats) || ('cargivers_count' in this.stats) || ('patients_activated_count' in this.stats) || ('therapies_started_count' in this.stats));
        },
        total_hcps(): number | undefined {
            let total = this.stats?.users_count?.map((data) => data.count)?.reduce((a, b) => { return a + b }, 0);
            return total;
        },
        therapies_started_count(): number | undefined {
            console.log(this.stats);
            let total = this.stats?.therapies_started_count?.map((data) => data.count)?.reduce((a, b,) => { return a + b }, 0);
            return total;
        }
    }
})
</script>